import { FieldError } from 'react-hook-form';

import { TEXTS } from '../ui/PromoRollSynthModal/texts';

export const getFieldErrorText = (error: FieldError | undefined, maxLength: number): string | undefined => {
  if (!error) return undefined;
  if (error.type === 'maxLength') return TEXTS.TEXT_MAX_LENGTH(maxLength);

  return TEXTS.FIELD_REQUIRED;
};
